import { render } from "./PhiDichVuVer2.vue?vue&type=template&id=de84da0a&scoped=true"
const script = {}

import "./PhiDichVuVer2.vue?vue&type=style&index=0&id=de84da0a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de84da0a"]])

export default __exports__